const getLastFullPageRouteName = state => {
    return state.routeName;
};

export default {
    getLastFullPageRouteName,
};
